import React from "react";
import { motion } from "framer-motion";

const sponsors = Array.from({ length: 6 }).map((_, i) => ({
  id: i + 1,
  label: "Sponsor Space",
  href: "#",
}));

export const SectionSponsors = () => {
  return (
    <section className="w-full pt-10 pb-20 bg-white flex flex-col justify-center items-center">
      <motion.h2
        className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-800 tracking-wide text-center mb-4"
        initial={{ opacity: 0, y: -15 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        viewport={{ once: true }}
      >
        Sponsor Space
      </motion.h2>

      <motion.p
        className="text-lg font-normal text-slate-700 max-w-[900px] mx-auto px-4 text-center mb-8"
        initial={{ opacity: 0, y: -15 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.15, ease: [0.4, 0, 0.2, 1] }}
        viewport={{ once: true }}
      >
        We are grateful for the organizations that support this event.
      </motion.p>

      {/* mobile: 2 columns, sm+: 3 columns — gap fixed at 4 */}
      <motion.div
        className="grid grid-cols-2 sm:grid-cols-3 gap-4 px-4 max-w-4xl w-full"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        viewport={{ once: true }}
      >
        {sponsors.map((s, idx) => (
          <motion.div
            key={s.id}
            // removed outer p-2 to avoid extra perceived spacing; gap-4 controls inter-item spacing
            className="relative group rounded-2xl overflow-hidden cursor-pointer flex items-center justify-center bg-transparent"
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.45,
              delay: 0.03 * idx,
              ease: "easeInOut",
            }}
          >
            <button
              type="button"
              onClick={() => {
                if (s.href && s.href !== "#") {
                  window.open(s.href, "_blank", "noopener,noreferrer");
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  if (s.href && s.href !== "#") {
                    window.open(s.href, "_blank", "noopener,noreferrer");
                  }
                }
              }}
              aria-label={`Sponsor slot ${s.id}`}
              // keep button padding so content doesn't touch edges
              className="w-full h-20 md:h-24 flex items-center justify-center rounded-xl bg-slate-100 text-slate-400 font-normal uppercase tracking-wide focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-500 focus-visible:ring-offset-2 transition-transform duration-200 transform hover:scale-[1.02] px-3"
            >
              <span className="text-sm md:text-base lg:text-lg">{s.label}</span>
            </button>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default SectionSponsors;
